module.exports = __webpack_public_path__ + "img/eh.04a2cf6c.svg";